<template>
    <div>
      <el-row style="margin-bottom:10px;">
        <el-col :span="18" class="flex">
          <el-select
            v-model="hasDelete"
            clearable
            @change="hasDeleteChange"
            size="small"
            placeholder="请选择项目状态"
          >
            <el-option
              v-for="item in hasDeleteData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-cascader
            ref="cascader"
            v-model="getProjectList_data.srId"
            clearable
            filterable
            size="small"
            placeholder="请选择区域"
            :show-all-levels="false"
            :options="getSysRegionList_data ? getSysRegionList_data.data : []"
            :props="{
              expandTrigger: 'hover',
              checkStrictly: true,
              emitPath: false,
              label: 'srName',
              value: 'srId',
              children: 'children'
            }"
            @change="$refs.cascader.dropDownVisible = false"
          >
            <template slot-scope="{ data }">
              <span onclick="this.parentNode.previousElementSibling.click()">{{
                data.srName
              }}</span>
            </template>
          </el-cascader>
          <el-input
            v-model="getProjectList_data.projectName"
            placeholder="请输入项目名"
            clearable
            size="small"
            style="max-width:380px;"
          />
          <el-button
            v-click.getProjectList
            type="primary"
            icon="el-icon-search"
            size="small"
            style="margin-left:10px;"
            >搜索
          </el-button>
        </el-col>
        <el-col :span="6">
          <!-- $form('addProject'), getUserListXm({ pageSize: 0, postId: 3 }), getUserListLs({ pageSize: 0, postId: 4 }) -->
          <el-button
            v-if="addProject"
            @click="diaLogOpen = true"
            size="small"
            type="primary"
            style="float:right"
            icon="el-icon-circle-plus"
            >添加项目
          </el-button>
        </el-col>
      </el-row>
  
      <mytable
        ref="mytable"
        :tableColums="tableColums_getProjectList"
        api="getProjectList::projectId"
        xupdateapi="updateProject"
        :height="H - 165"
        :tree="{ children: 'projectChildren', lazy: lazyLoad }"
        @expand="expand"
        @hasChildrenChange="hasChildrenChange"
        @cell-mouse-enter="cellMouseEnter"
        @cell-mouse-leave="cellMouseLeave"
      >
        <div slot="projectNumSts" slot-scope="{ row }">
          <span style="margin-top: 20px;padding: 0 5px;color:#409EFF;">
            {{ row.projectNumSts }}
          </span>
          <el-button
            v-if="rowShow == row.projectId && columnShow == 'projectNumSts'"
            size="mini"
            type="text"
            style="color: red;margin-left:5px;"
            @click="
              $form('getProjectUserList'), (projectIdTwo = row.projectId);
              getData();
            "
            >查看</el-button
          >
        </div>
        <div slot="projectProgressTime" slot-scope="{ row }">
          <div
            style="margin-top: 20px;padding: 0 15px;"
            v-if="
              row.projectParentId !== 0 ||
                (row.projectParentId == 0 && row.projectType == 2)
            "
          >
            <el-progress
              :text-inside="true"
              :stroke-width="20"
              :percentage="row.projectProgressTime"
            ></el-progress>
          </div>
        </div>
        <div slot="projectProgressTarget" slot-scope="{ row }">
          <div
            style="margin-top: 20px;padding: 0 15px;"
            v-if="
              row.projectParentId !== 0 ||
                (row.projectParentId == 0 && row.projectType == 2)
            "
          >
            <el-progress
              :text-inside="true"
              :stroke-width="20"
              :percentage="row.projectProgressTarget"
              status="success"
            ></el-progress>
          </div>
        </div>
        <div slot="projectProgressDes" slot-scope="{ row }">
          <el-tag
            v-if="row.projectProgressDes"
            :type="
              row.projectProgressDes == '红色预警'
                ? 'danger'
                : row.projectProgressDes == '黄色预警'
                ? 'warning'
                : 'success'
            "
            >预警</el-tag
          >
        </div>
        <div slot="projectManagerIdListStringTwo" slot-scope="{ row }">
          {{
            row.projectParentId == 0 && row.projectType == 1
              ? row.projectManagerIdListStringMain
              : "" || ""
          }}
          <i
            v-if="
              rowShow == row.projectId &&
                columnShow == 'projectManagerIdListStringTwo' &&
                row.projectParentId == 0 &&
                row.projectType == 1
            "
            class="el-icon-edit-outline"
            style="font-size: 20px;margin-left: 10px;"
            @click="
              DiaLogEditClick(
                1,
                row,
                2,
                getUserListXm_data.data,
                row.projectManagerIdListMain,
                'userId',
                'userName',
                'projectManagerIdList',
                '项目统筹'
              )
            "
          ></i>
        </div>
        <div slot="projectManagerIdListString" slot-scope="{ row }">
          {{ row.projectManagerIdListString || "" }}
          <i
            v-if="
              rowShow == row.projectId &&
                columnShow == 'projectManagerIdListString' &&
                (row.projectParentId !== 0 ||
                  (row.projectParentId == 0 && row.projectType == 2))
            "
            class="el-icon-edit-outline"
            style="font-size: 20px;margin-left: 10px;"
            @click="
              DiaLogEditClick(
                1,
                row,
                2,
                getUserListXm_data.data,
                row.projectManagerIdList,
                'userId',
                'userName',
                'projectManagerIdList',
                '项目经理'
              )
            "
          ></i>
        </div>
        <div slot="projectTeacherIdListString" slot-scope="{ row }">
          {{ row.projectTeacherIdListString || "" }}
          <i
            v-if="
              rowShow == row.projectId &&
                columnShow == 'projectTeacherIdListString' &&
                (row.projectParentId !== 0 ||
                  (row.projectParentId == 0 && row.projectType == 2))
            "
            class="el-icon-edit-outline"
            style="font-size: 20px;margin-left: 10px;"
            @click="
              DiaLogEditClick(
                1,
                row,
                2,
                getUserListLs_data.data,
                row.projectTeacherIdList,
                'userId',
                'userName',
                'projectTeacherIdList',
                '项目老师'
              )
            "
          ></i>
        </div>
        <div slot="projectStartTime" slot-scope="{ row }">
          {{ row.projectStartTime || "" }}
          <i
            v-if="rowShow == row.projectId && columnShow == 'projectStartTime'"
            class="el-icon-edit-outline"
            style="font-size: 20px;margin-left: 10px;"
            @click="
              DiaLogEditClick(
                2,
                row,
                5,
                [],
                row.projectStartTime,
                '',
                '',
                'projectStartTime',
                '开始时间',
                'projectEndTime',
                row.projectEndTime
              )
            "
          ></i>
        </div>
        <div slot="projectEndTime" slot-scope="{ row }">
          {{ row.projectEndTime || "" }}
          <i
            v-if="rowShow == row.projectId && columnShow == 'projectEndTime'"
            class="el-icon-edit-outline"
            style="font-size: 20px;margin-left: 10px;"
            @click="
              DiaLogEditClick(
                2,
                row,
                5,
                [],
                row.projectStartTime,
                '',
                '',
                'projectStartTime',
                '结束时间',
                'projectEndTime',
                row.projectEndTime
              )
            "
          ></i>
        </div>
        <div
          slot="projectName"
          slot-scope="{ row }"
          style="color: cornflowerblue;"
        >
          <div @click="projectDetailClick(row)">{{ row.projectName || "" }}</div>
        </div>
      </mytable>
      <myform
        :viewobj="{
          getProjectUserList: ['项目人员列表', 'el-icon-circle-plus']
        }"
      >
        <hide slot="currentPage" />
        <hide slot="pageSize" />
        <mytable
          ref="myUserTable"
          :tableColums="tableColums_getProjectUserList"
          api="getProjectUserList::projectId"
          xupdateapi="updateProject"
          :height="H - 165"
        >
        </mytable>
      </myform>
      <myform
        :viewobj="{
          addUserProject: ['新增账号信息', 'el-icon-circle-plus'],
          updateUser: ['修改账号信息', 'el-icon-edit-outline'],
          $succeed$: getProjectUserList
        }"
        @close="$form('updateUser', 'reset')"
      >
        <!-- 岗位id -->
        <template v-slot:postId="{ Myformdata }">
          <el-select v-model="Myformdata.postId" clearable>
            <el-option
              v-for="item in getPostList_data.data || []"
              :key="item.postId"
              :label="item.postName"
              :value="item.postId"
            >
            </el-option>
          </el-select>
        </template>
        <!-- 类型id -->
        <template v-slot:yutId="{ Myformdata }">
          <el-select v-model="Myformdata.yutId" clearable>
            <el-option
              v-for="item in getUserTypeList_data.data || []"
              :key="item.yutId"
              :label="item.yutName"
              :value="item.yutId"
            >
            </el-option>
          </el-select>
        </template>
  
        <!-- 角色权限 -->
        <template v-slot:roleListString="{ Myformdata }">
          <el-select v-model="Myformdata.roleListString" multiple clearable>
            <el-option
              v-for="item in getRoleList_data.data || []"
              :key="item.roleId"
              :label="item.roleName"
              :value="item.roleId"
            >
            </el-option>
          </el-select>
        </template>
        <!-- 角色权限 -->
        <template v-slot:dtId="{ Myformdata }">
          <el-select v-model="Myformdata.dtId" clearable>
            <el-option
              v-for="item in getDepartmentList_data.data || []"
              :key="item.dtId"
              :label="item.dtName"
              :value="item.dtId"
            >
            </el-option>
          </el-select>
        </template>
  
        <template v-slot:loginApp="{ Myformdata }">
          <el-radio v-model="Myformdata.loginApp" :label="1">是</el-radio>
          <el-radio v-model="Myformdata.loginApp" :label="2">否</el-radio>
        </template>
        <template v-slot:loginPc="{ Myformdata }">
          <el-radio v-model="Myformdata.loginPc" :label="1">是</el-radio>
          <el-radio v-model="Myformdata.loginPc" :label="2">否</el-radio>
        </template>
        <template v-slot:targetJs="{ Myformdata }">
          <el-input
            v-model="Myformdata.targetJs"
            type="number"
            placeholder="可再次输入签约总家数..."
          ></el-input>
        </template>
        <template v-slot:targetJe="{ Myformdata }">
          <el-input
            v-model="Myformdata.targetJe"
            type="number"
            placeholder="可再次输入签约总金额..."
          ></el-input>
        </template>
        <template v-slot:targetSl="{ Myformdata }">
          <el-input
            v-model="Myformdata.targetSl"
            type="number"
            placeholder="可再次输入签约总数量..."
          ></el-input>
        </template>
        <template v-slot:userVisitorTargetCount="{ Myformdata }">
          <el-input
            v-model="Myformdata.userVisitorTargetCount"
            type="number"
            placeholder="可再次输入每日走访目标..."
          ></el-input>
        </template>
        <template v-slot:userOrderMoneyTarget="{ Myformdata }">
          <el-input
            v-model="Myformdata.userOrderMoneyTarget"
            type="number"
            placeholder="可再次输入每日签单目标..."
          ></el-input>
        </template>
        <!-- 隐藏指定字段 -->
        <hide slot="userId" />
      </myform>
      <myform
        :viewobj="{
          addProject: ['新增项目信息', 'el-icon-circle-plus'],
          updateProject: ['修改项目信息', 'el-icon-edit-outline'],
          $succeed$: getData
        }"
        @close="$form('updateProject', 'reset')"
      >
        <template v-slot:projectStartTime="{ Myformdata }">
          <el-date-picker
            v-model="Myformdata.projectStartTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择开始日期"
          >
          </el-date-picker>
        </template>
        <template v-slot:projectEndTime="{ Myformdata }">
          <el-date-picker
            v-model="Myformdata.projectEndTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择结束日期"
          >
          </el-date-picker>
        </template>
        <template v-slot:projectOrderTimeEnd="{ Myformdata }">
          <el-date-picker
            v-model="Myformdata.projectOrderTimeEnd"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择订单截止时间"
          >
          </el-date-picker>
        </template>
        <template v-slot:projectManagerIdList="{ Myformdata }">
          <el-select
            v-model="Myformdata.projectManagerIdList"
            multiple
            clearable
            filterable
          >
            <el-option
              v-for="item in getUserListXm_data.data || []"
              :key="item.userId"
              :label="item.userName"
              :value="item.userId"
            >
            </el-option>
          </el-select>
        </template>
        <template v-slot:projectTeacherIdList="{ Myformdata }">
          <el-select
            v-model="Myformdata.projectTeacherIdList"
            multiple
            clearable
            filterable
          >
            <el-option
              v-for="item in getUserListLs_data.data || []"
              :key="item.userId"
              :label="item.userName"
              :value="item.userId"
            >
            </el-option>
          </el-select>
        </template>
        <template v-slot:srId="{ Myformdata }">
          <el-cascader
            ref="cascader"
            v-model="Myformdata.srId"
            clearable
            filterable
            size="small"
            placeholder="请选择区域"
            :show-all-levels="false"
            :options="getSysRegionList_data ? getSysRegionList_data.data : []"
            :props="{
              expandTrigger: 'hover',
              checkStrictly: true,
              emitPath: false,
              label: 'srName',
              value: 'srId',
              children: 'children'
            }"
            @change="$refs.cascader.dropDownVisible = false"
          >
            <template slot-scope="{ data }">
              <span onclick="this.parentNode.previousElementSibling.click()">{{
                data.srName
              }}</span>
            </template>
          </el-cascader>
        </template>
        <template v-slot:microlecturePassStatus="{ Myformdata }">
          <el-select v-model="Myformdata.microlecturePassStatus">
            <el-option label="不校验" :value="1"> </el-option>
            <el-option label="校验" :value="2"> </el-option>
          </el-select>
        </template>
        <hide slot="projectId" />
      </myform>
  
      <myform
        view.updateProjectAuth="分配权限#el-icon-edit-outline#保存"
        id="FormTop"
        @opened="arguments[0].title += ' | @' + row.projectName"
        @close="
          $form('updateProjectAuth', 'hide'),
            (getRoleAuthListByProjectAll_data.data = [])
        "
        confirm="$refs.ElTree.getCheckedKeys()"
      >
        <hide slot="projectId" />
        <hide slot="authListString" />
        <template v-slot>
          <el-tree
            ref="ElTree"
            :data="getRoleAuthListByProjectAll_data.data || []"
            show-checkbox
            check-on-click-node
            @check="
              Myformdata.authListString =
                arguments[1].halfCheckedKeys.concat(arguments[1].checkedKeys) + ''
            "
            node-key="authId"
            :props="{
              children: 'children',
              label: 'authName'
            }"
            highlight-current
          >
          </el-tree>
        </template>
      </myform>
  
      <myform
        view.addProjectUser="项目其他管理人员"
        @opened="arguments[0].title += ' | @' + row.projectName"
        @close="$form('addProjectUser', 'hide')"
      >
        <template v-slot:puLeader="{ Myformdata }">
          <el-radio v-model="Myformdata.puLeader" :label="1">查看</el-radio>
          <el-radio v-model="Myformdata.puLeader" :label="2">编辑</el-radio>
        </template>
        <template v-slot:userId="{ Myformdata }">
          <el-select v-model="Myformdata.userId" clearable filterable>
            <el-option
              v-for="item in getUserListPostProject_data.data || []"
              :key="item.userId"
              :label="item.userName"
              :value="item.userId"
            >
            </el-option>
          </el-select>
          <el-button
            type="primary"
            icon="el-icon-circle-plus"
            @click="
              $form('addProjectUser', 'submit').then(s =>
                getProjectUser({ projectId: row.projectId })
              )
            "
            >添加</el-button
          >
        </template>
  
        <mytable
          :tableColums="tableColums_getProjectUser"
          api="getProjectUser"
          :height="H - 285"
        />
        <hide slot="projectId" />
      </myform>
      <myform
        view.getProjectOneStatistic="项目数据"
        @opened="arguments[0].title += ' | @' + row.projectName"
        @close="$form('getProjectOneStatistic', 'hide')"
      >
        <template v-if="getProjectOneStatistic_data.data">
          <el-card
            class="box-card"
            v-if="getProjectOneStatistic_data && getProjectOneStatistic_data.data"
          >
            <div slot="header" class="clearfix">
              <span
                >项目名称：{{
                  getProjectOneStatistic_data.data.project.projectName
                }}</span
              >
            </div>
            <el-row>
              <el-col :span="12">
                <div class="text item">
                  开始时间：{{
                    getProjectOneStatistic_data.data.project.projectStartTime
                  }}
                </div>
                <div class="text item">
                  结束时间：{{
                    getProjectOneStatistic_data.data.project.projectEndTime
                  }}
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <div class="text item">
                  排行榜维度：
                  <span
                    v-if="
                      getProjectOneStatistic_data.data.project.projectRankType &&
                        getProjectOneStatistic_data.data.project
                          .projectRankType == 2
                    "
                    >年化金额</span
                  >
                  <span v-else>总金额</span>
                </div>
              </el-col>
              <el-col :span="4">
                <el-button
                  v-if="updateProjectRankType"
                  style="padding: 3px 0"
                  type="text"
                  @click="toUpdateProjectRankType"
                  >修改</el-button
                >
              </el-col>
            </el-row>
            <el-row>
              <div class="text item">
                项目描述：{{
                  getProjectOneStatistic_data.data.project.projectRemark
                }}
              </div>
            </el-row>
          </el-card>
          <el-card
            class="box-card"
            v-if="getProjectOneStatistic_data && getProjectOneStatistic_data.data"
          >
            <el-row>
              <el-col :span="12">
                <div class="text item">
                  订单提交截止时间：{{
                    getProjectOneStatistic_data.data.project.projectOrderTimeEnd
                  }}
                </div>
              </el-col>
              <el-col :span="4">
                <el-button
                  v-if="updateProjectOrderTimeEnd"
                  style="padding: 3px 0"
                  type="text"
                  @click="toUpdateProjectOrderTimeEnd"
                  >修改</el-button
                >
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <div class="text item">
                  项目经理：{{
                    getProjectOneStatistic_data.data.project
                      .projectManagerIdListString
                  }}
                </div>
                <div class="text item">
                  项目老师：{{
                    getProjectOneStatistic_data.data.project
                      .projectTeacherIdListString
                  }}
                </div>
                <div class="text item">
                  其他人员：{{
                    getProjectOneStatistic_data.data.project
                      .projectOtherIdListString
                  }}
                </div>
              </el-col>
            </el-row>
          </el-card>
          <el-card
            class="box-card"
            v-if="getProjectOneStatistic_data && getProjectOneStatistic_data.data"
          >
            <div>学员数量:{{ getProjectOneStatistic_data.data.userStsNum }}</div>
            <div>
              其他用户:{{ getProjectOneStatistic_data.data.userOtherNum }}
            </div>
            <div>客户数量:{{ getProjectOneStatistic_data.data.customNum }}</div>
            <div>
              打卡数量:{{ getProjectOneStatistic_data.data.userVisitorNum }}
            </div>
            <div>
              商机数量:{{ getProjectOneStatistic_data.data.opportunityOuNum }}
            </div>
            <div>
              订单数量:{{ getProjectOneStatistic_data.data.opportunityOrderNum }}
            </div>
            <div>
              你问我答:{{ getProjectOneStatistic_data.data.circleLetterThreeNum }}
            </div>
            <div>
              案例分享:{{ getProjectOneStatistic_data.data.circleLetterOneNum }}
            </div>
          </el-card>
          <el-card
            class="box-card"
            v-if="getProjectOneStatistic_data && getProjectOneStatistic_data.data"
          >
            <div
              v-for="(item, index) in getProjectOneStatistic_data.data
                .loginLastTimeList"
              :key="index"
            >
              <el-row>
                <el-col :span="8">用户名:{{ item.userName }}</el-col>
                <!-- 1系统管理员 2项目战队管理者 3项目经理 4老师 5学员 6平台项目管理员 -->
                <el-col :span="8"
                  >岗位:
                  <span v-if="item.puType == 1">系统管理员</span>
                  <span v-if="item.puType == 2">项目战队管理者</span>
                  <span v-if="item.puType == 3">项目经理</span>
                  <span v-if="item.puType == 4">老师</span>
                  <span v-if="item.puType == 5">学员</span>
                  <span v-if="item.puType == 6">平台项目管理员</span>
                </el-col>
                <el-col :span="8">活跃时间:{{ item.loginLastTime }}</el-col>
              </el-row>
            </div>
          </el-card>
        </template>
        <hide slot="projectId" />
      </myform>
      <el-dialog
        :title="IsEdit ? '编辑项目' : '新建项目'"
        :visible.sync="diaLogOpen"
        width="80%"
        :before-close="handleClose"
      >
        <el-form
          ref="form"
          :model="form"
          label-position="left"
          label-width="130px"
          @submit.native.prevent
        >
          <el-form-item label="项目名称">
            <el-input
              v-model="form.projectName"
              style="width: 80%;"
              placeholder="请输入项目名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="项目类型">
            <el-radio-group v-model="form.projectType" :disabled="IsEdit">
              <el-radio :label="1">统筹</el-radio>
              <el-radio :label="2">单训战</el-radio>
              <el-radio :label="3">驻训</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="!form.projectId">
            <div style="width: 100%;display: flex;flex-direction: row-reverse;">
              <el-button @click="handleClose">取 消</el-button>
              <el-button
                type="primary"
                @click="sureProject"
                style="margin-right: 15px;"
                >确 定</el-button
              >
            </div>
          </el-form-item>
          <div v-else>
            <el-form-item label="项目领域">
              <el-radio-group v-model="form.projectRange">
                <el-radio label="政企">政企</el-radio>
                <el-radio label="大市场">大市场</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="区域">
              <el-cascader
                :key="keyValue"
                v-model="form.srId"
                :options="zone_arr"
                :props="props"
                ref="cascader2"
                :show-all-levels="false"
                @change="handleChange2"
                placeholder="请选择区域"
                style="width: 50%;"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="项目区域及目标" v-if="form.projectType == 1">
              <div
                style="width: 90%;margin: 0 auto; display: flex;flex-direction: row-reverse;"
              >
                <el-button
                  v-if="addProjectChild"
                  @click="$form('addProjectChild')"
                  size="small"
                  type="primary"
                  icon="el-icon-circle-plus"
                  >添加项目人员
                </el-button>
              </div>
              <div>
                <el-table
                  :data="
                    getProjectOne_data.data
                      ? getProjectOne_data.data.projectChildren
                      : []
                  "
                  stripe
                  border
                  style="width: 100%"
                  max-height="300px"
                  :cell-style="{ textAlign: 'center' }"
                  :header-cell-style="{
                    textAlign: 'center',
                    background: 'rgba(0,170,255,0.5)',
                    color: 'black',
                    border: 'none'
                  }"
                >
                  <el-table-column type="index" label="序号"> </el-table-column>
                  <el-table-column prop="srName" label="区域"> </el-table-column>
                  <el-table-column
                    prop="projectTeacherIdListString"
                    label="项目老师"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="projectManagerIdListString"
                    label="项目经理"
                  >
                  </el-table-column>
                  <el-table-column prop="userTargetList" label="目标">
                    <template slot-scope="scope">
                      <div
                        v-for="(item, index) in scope.row.userTargetList"
                        :key="index"
                        :style="{ color: item.utMain == 2 ? 'red' : 'black' }"
                      >
                        类型:{{
                          item.utTypeTwo == 1
                            ? "打卡"
                            : item.utTypeTwo == 2
                            ? "金额"
                            : item.utTypeTwo == 3
                            ? "单数"
                            : "业务数"
                        }}
                        业务:{{ item.bcName }} 目标:{{ item.utTarget }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        type="text"
                        @click="handleEdit(scope.$index, scope.row)"
                        >编辑</el-button
                      >
                      <el-button
                        size="mini"
                        type="text"
                        @click="handleDelete(scope.$index, scope.row)"
                        style="color: red"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
            <el-form-item label="项目区域及目标" v-if="form.projectType != 1">
              <div
                style="width: 80%;display: flex;justify-content: space-around;"
              >
                <div>
                  <span>项目经理:</span>
                  <span
                    ><el-select
                      v-model="form.projectManagerIdList"
                      multiple
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in getUserListXm_data.data || []"
                        :key="item.userId"
                        :label="item.userName"
                        :value="item.userId"
                      >
                      </el-option>
                    </el-select>
                  </span>
                </div>
                <div>
                  <span>项目老师:</span>
                  <span>
                    <el-select
                      v-model="form.projectTeacherIdList"
                      multiple
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in getUserListLs_data.data || []"
                        :key="item.userId"
                        :label="item.userName"
                        :value="item.userId"
                      >
                      </el-option>
                    </el-select>
                  </span>
                </div>
              </div>
              <div>
                <div
                  style="width:100%;display:flex;flex-direction: row-reverse;margin: 10px auto;"
                >
                  <el-button
                    @click="add_arr"
                    size="small"
                    type="primary"
                    style="margin-right: 30px;"
                    icon="el-icon-circle-plus"
                    >新增目标
                  </el-button>
                </div>
                <el-card
                  style="width: 100%;margin:15px 0;"
                  v-for="(item, index) in userTargetListString || []"
                  :key="index"
                >
                  <el-select
                    v-model="item.utTypeTwo"
                    size="small"
                    style="width: 150px"
                    aria-placeholder="请选择维度类型"
                  >
                    <el-option :key="0" label="打卡" :value="1"></el-option>
                    <el-option :key="1" label="金额" :value="2"></el-option>
                    <el-option :key="2" label="单数" :value="3"></el-option>
                    <el-option :key="3" label="业务数" :value="4"></el-option>
                  </el-select>
                  <el-cascader
                    ref="cascader2"
                    v-model="item.bcId"
                    clearable
                    filterable
                    size="small"
                    :disabled="item.utStatus"
                    :placeholder="item.bcId ? item.bcName : '请选择业务'"
                    :show-all-levels="false"
                    :options="
                      getBusinessClassList_data
                        ? getBusinessClassList_data.data
                        : []
                    "
                    :props="propsTwo"
                    style="width: 150px;"
                  >
                    <template slot-scope="{ data }">
                      <span
                        onclick="this.parentNode.previousElementSibling.click()"
                        >{{ data.bcName }}</span
                      >
                    </template>
                  </el-cascader>
                  <el-input
                    v-model="item.utTarget"
                    size="small"
                    placeholder="请输入目标值"
                    style="width: 150px;"
                  ></el-input>
                  <el-radio-group v-model="item.utMain" style="width: 300px;">
                    <el-radio :label="1">不是主目标</el-radio>
                    <el-radio :label="2">是主目标</el-radio>
                  </el-radio-group>
                  <el-button
                    @click="del_arr(index)"
                    size="small"
                    type="primary"
                    style="float:right"
                    >删除
                  </el-button>
                </el-card>
              </div>
            </el-form-item>
            <el-form-item label="项目描述">
              <el-input
                v-model="form.projectRemark"
                style="width: 80%;"
                placeholder="请输入项目描述"
              ></el-input>
            </el-form-item>
            <el-form-item label="项目周期">
              <el-date-picker
                v-model="form.projectStartTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择开始日期"
              >
              </el-date-picker>
              <span>---</span>
              <el-date-picker
                v-model="form.projectEndTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择结束日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="微课匹配度校验">
              <el-select v-model="form.microlecturePassStatus">
                <el-option label="不校验" :value="1"> </el-option>
                <el-option label="校验" :value="2"> </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
        <div
          slot="footer"
          class="dialog-footer"
          style="width: 80%; margin: 10px auto"
          v-if="form.projectId"
        >
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="success" @click="btnSure">确定</el-button>
        </div>
      </el-dialog>
      <!-- 项目子集 -->
      <myform
        :viewobj="{
          addProjectChild: ['新增项目区域及目标', 'el-icon-circle-plus'],
          updateProjectManage: ['修改项目区域及目标', 'el-icon-edit-outline']
        }"
        @close="
          $form('updateProjectManage', 'reset'),
            (userTargetListString = [
              {
                utTypeTwo: '',
                bcId: '',
                utTarget: '',
                utId: '',
                utMain: 1
              }
            ]),
            getProjectOne({ projectId: form.projectId })
        "
        @confirm="myformTable"
      >
        <template v-slot:srId="{ Myformdata }">
          <el-cascader
            v-model="Myformdata.srId"
            :options="zone_arr"
            :props="props"
            ref="cascader"
            :show-all-levels="false"
            @change="handleChange3"
            :placeholder="Myformdata.srId ? Myformdata.srName : '请选择区域'"
            style="width: 50%;"
          ></el-cascader>
        </template>
        <template v-slot:projectManagerIdList="{ Myformdata }">
          <el-select
            v-model="Myformdata.projectManagerIdList"
            multiple
            clearable
            filterable
          >
            <el-option
              v-for="item in getUserListXm_data.data || []"
              :key="item.userId"
              :label="item.userName"
              :value="item.userId"
            >
            </el-option>
          </el-select>
        </template>
        <template v-slot:projectTeacherIdList="{ Myformdata }">
          <el-select
            v-model="Myformdata.projectTeacherIdList"
            multiple
            clearable
            filterable
          >
            <el-option
              v-for="item in getUserListLs_data.data || []"
              :key="item.userId"
              :label="item.userName"
              :value="item.userId"
            >
            </el-option>
          </el-select>
        </template>
        <template v-slot:userTargetListString="{ Myformdata }">
          <div
            style="width:100%;display:flex;flex-direction: row-reverse;margin: 10px auto;"
          >
            <el-button
              @click="add_arr"
              size="small"
              type="primary"
              style="margin-right: 30px;"
              icon="el-icon-circle-plus"
              >新增目标
            </el-button>
          </div>
          <el-card
            style="width: 100%;margin:15px 0;"
            v-for="(item, index) in userTargetListString || []"
            :key="index"
          >
            <el-select
              v-model="item.utTypeTwo"
              size="small"
              style="width: 150px"
              aria-placeholder="请选择维度类型"
            >
              <el-option :key="0" label="打卡" :value="1"></el-option>
              <el-option :key="1" label="金额" :value="2"></el-option>
              <el-option :key="2" label="单数" :value="3"></el-option>
              <el-option :key="3" label="业务数" :value="4"></el-option>
            </el-select>
            <el-cascader
              ref="cascader2"
              v-model="item.bcId"
              clearable
              filterable
              :disabled="item.utStatus"
              size="small"
              :placeholder="item.bcId ? item.bcName : '请选择业务'"
              :show-all-levels="false"
              :options="
                getBusinessClassList_data ? getBusinessClassList_data.data : []
              "
              :props="propsTwo"
              style="width: 150px;"
            >
              <template slot-scope="{ data }">
                <span onclick="this.parentNode.previousElementSibling.click()">{{
                  data.bcName
                }}</span>
              </template>
            </el-cascader>
            <el-input
              v-model="item.utTarget"
              size="small"
              placeholder="请输入目标值"
              style="width: 150px;"
            ></el-input>
            <el-radio-group v-model="item.utMain" style="width: 300px;">
              <el-radio :label="1">不是主目标</el-radio>
              <el-radio :label="2">是主目标</el-radio>
            </el-radio-group>
            <el-button
              @click="del_arr(index)"
              size="small"
              type="primary"
              style="float:right"
              >删除
            </el-button>
          </el-card>
        </template>
        <hide slot="projectId" />
        <hide slot="projectParentId" />
      </myform>
      <el-dialog
        :title="'编辑' + diaLogEditValue.title"
        :visible.sync="diaLogEdit"
        width="20%"
        :before-close="handleDiaLogEditClose"
        center
      >
        <div v-if="dialogType == 1">
          <el-select v-model="diaLogEditValue.value" clearable filterable>
            <el-option
              v-for="item in diaLogEditValue.dataArr || []"
              :key="item[diaLogEditValue.keyId]"
              :label="item[diaLogEditValue.keyName]"
              :value="item[diaLogEditValue.keyId]"
            >
            </el-option>
          </el-select>
        </div>
        <div v-if="dialogType == 2">
          <el-select
            v-model="diaLogEditValue.value"
            multiple
            clearable
            filterable
          >
            <el-option
              v-for="item in diaLogEditValue.dataArr || []"
              :key="item[diaLogEditValue.keyId]"
              :label="item[diaLogEditValue.keyName]"
              :value="item[diaLogEditValue.keyId]"
            >
            </el-option>
          </el-select>
        </div>
        <div v-if="dialogType == 3">
          <el-cascader
            v-model="diaLogEditValue.value"
            :options="diaLogEditValue.dataArr"
            :props="props"
            ref="cascaders"
            :show-all-levels="false"
            @change="DialogEditChange"
            placeholder="请选择"
            style="width: 80%;"
          ></el-cascader>
        </div>
        <div v-if="dialogType == 4">
          <el-date-picker
            v-model="diaLogEditValue.value"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
        </div>
        <div v-if="dialogType == 5">
          <el-date-picker
            v-model="diaLogEditValue.value"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择开始日期"
          >
          </el-date-picker>
          <span>---</span>
          <el-date-picker
            v-model="diaLogEditValue.valueTwo"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择结束日期"
          >
          </el-date-picker>
        </div>
        <div v-if="dialogType == 6">
          <el-radio-group v-model="diaLogEditValue.valueTwo">
            <el-radio
              v-for="item in diaLogEditValue.dataArr || []"
              :key="item[diaLogEditValue.keyId]"
              :label="item[diaLogEditValue.keyId]"
              >{{ item[diaLogEditValue.keyName] }}</el-radio
            >
          </el-radio-group>
        </div>
        <div
          slot="footer"
          class="dialog-footer"
          style="width: 80%; margin: 10px auto"
        >
          <el-button @click="handleDiaLogEditClose">取 消</el-button>
          <el-button type="success" @click="DiaLogEditSure">确定</el-button>
        </div>
      </el-dialog>
      <!-- 项目详情 -->
      <el-dialog
        title="项目详情"
        :visible.sync="projectDetail"
        width="80%"
        :before-close="projectDetailClose"
      >
        <div style="width:100%;display:flex;flex-direction: row-reverse;">
          <el-button
            v-if="!IsEdit"
            @click="IsEdit = true"
            size="small"
            type="primary"
            style="margin-right: 30px;"
            icon="el-icon-circle-plus"
            >编辑
          </el-button>
          <el-button
            @click="IsEdit = false"
            size="small"
            type="primary"
            v-if="IsEdit"
            style="margin-right: 30px;"
            >取消编辑
          </el-button>
        </div>
        <el-card>
          <el-collapse v-model="activeNum" @change="activeNumChange">
            <el-collapse-item title="项目基本信息" name="1">
              <el-form
                ref="form"
                :model="form"
                label-position="left"
                label-width="130px"
                @submit.native.prevent
                v-if="!IsEdit"
              >
                <el-form-item label="项目名称">
                  <div>{{ form.projectName || "" }}</div>
                </el-form-item>
                <el-form-item label="项目类型">
                  <el-tag
                    v-if="form.projectType"
                    :type="
                      form.projectType == 1
                        ? 'success'
                        : form.projectType == 2
                        ? 'danger'
                        : ''
                    "
                    >{{
                      form.projectType == 1
                        ? "统筹"
                        : form.projectType == 2
                        ? "单训战"
                        : "驻训" || ""
                    }}</el-tag
                  >
                </el-form-item>
                <el-form-item label="项目领域">
                  <el-tag
                    v-if="form.projectRange"
                    :type="form.projectRange == '政企' ? 'success' : 'danger'"
                    >{{ form.projectRange || "" }}</el-tag
                  >
                </el-form-item>
                <el-form-item label="区域">
                  <div>{{ form.srName || "" }}</div>
                </el-form-item>
                <div
                  style="width:100%;display:flex;justify-content:space-between"
                >
                  <el-form-item label="项目统筹总数">
                    <div>
                      {{
                        form.projectManagerIdListMain
                          ? form.projectManagerIdListMain.length
                          : "" || ""
                      }}
                    </div>
                  </el-form-item>
                  <el-form-item label="项目学员总数">
                    <div>{{ form.projectNumSts || "" }}</div>
                  </el-form-item>
                  <el-form-item label="客户总数">
                    <div>{{ form.customNums || "" }}</div>
                  </el-form-item>
                </div>
  
                <el-form-item label="项目区域及目标" v-if="form.projectType == 1">
                  <div>
                    <el-table
                      :data="
                        getProjectOne_data.data
                          ? getProjectOne_data.data.projectChildren
                          : []
                      "
                      stripe
                      border
                      style="width: 100%"
                      max-height="300px"
                      :cell-style="{ textAlign: 'center' }"
                      :header-cell-style="{
                        textAlign: 'center',
                        background: 'rgba(0,170,255,0.5)',
                        color: 'black',
                        border: 'none'
                      }"
                    >
                      <el-table-column type="index" label="序号">
                      </el-table-column>
                      <el-table-column prop="srName" label="区域">
                      </el-table-column>
  
                      <el-table-column
                        prop="projectTeacherIdListString"
                        label="项目老师"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="projectManagerIdListString"
                        label="项目经理"
                      >
                      </el-table-column>
                      <el-table-column prop="userTargetList" label="目标">
                        <template slot-scope="scope">
                          <div
                            v-for="(item, index) in scope.row.userTargetList"
                            :key="index"
                            :style="{ color: item.utMain == 2 ? 'red' : 'black' }"
                          >
                            类型:{{
                              item.utTypeTwo == 1
                                ? "打卡"
                                : item.utTypeTwo == 2
                                ? "金额"
                                : item.utTypeTwo == 3
                                ? "单数"
                                : "业务数"
                            }}
                            业务:{{ item.bcName }} 目标:{{ item.utTarget }}
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </el-form-item>
                <div
                  style="width:100%;display:flex;"
                  v-if="form.projectType != 1"
                >
                  <el-form-item label="项目经理" style="width:50%">
                    <div>{{ form.projectManagerIdListString || "" }}</div>
                  </el-form-item>
                  <el-form-item label="项目老师">
                    <div>{{ form.projectTeacherIdListString || "" }}</div>
                  </el-form-item>
                </div>
                <el-form-item label="目标" v-if="form.projectType != 1">
                  <div
                    v-for="(item, index) in form.userTargetList"
                    :key="index"
                    :style="{ color: item.utMain == 2 ? 'red' : 'black' }"
                  >
                    类型:{{
                      item.utTypeTwo == 1
                        ? "打卡"
                        : item.utTypeTwo == 2
                        ? "金额"
                        : item.utTypeTwo == 3
                        ? "单数"
                        : "业务数"
                    }}
                    业务:{{ item.bcName }} 目标:{{ item.utTarget }}
                  </div>
                </el-form-item>
                <el-form-item label="项目描述">
                  <div>{{ form.projectRemark || "" }}</div>
                </el-form-item>
                <el-form-item label="项目周期">
                  <div>
                    {{ form.projectStartTime || "" }} ---
                    {{ form.projectEndTime || "" }}
                  </div>
                </el-form-item>
                <el-form-item label="微课匹配度校验">
                  <div>
                    {{
                      form.microlecturePassStatus == 1 ? "不校验" : "校验" || ""
                    }}
                  </div>
                </el-form-item>
              </el-form>
              <el-form
                ref="form"
                :model="form"
                label-position="left"
                label-width="130px"
                @submit.native.prevent
                v-if="IsEdit"
              >
                <el-form-item label="项目名称">
                  <el-input
                    v-model="form.projectName"
                    style="width: 80%;"
                    placeholder="请输入项目名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="项目类型">
                  <el-radio-group v-model="form.projectType" :disabled="IsEdit">
                    <el-radio :label="1">统筹</el-radio>
                    <el-radio :label="2">单训战</el-radio>
                    <el-radio :label="3">驻训</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="项目领域">
                  <el-radio-group v-model="form.projectRange">
                    <el-radio label="政企">政企</el-radio>
                    <el-radio label="大市场">大市场</el-radio>
                  </el-radio-group>
                </el-form-item>
  
                <el-form-item label="区域">
                  <el-cascader
                    :key="keyValue"
                    v-model="form.srId"
                    :options="zone_arr"
                    :props="props"
                    ref="cascader2"
                    :show-all-levels="false"
                    @change="handleChange2"
                    placeholder="请选择区域"
                    style="width: 50%;"
                  ></el-cascader>
                </el-form-item>
                <div
                  style="width:100%;display:flex;justify-content:space-between"
                >
                  <el-form-item label="项目统筹总数">
                    <div>
                      {{
                        form.projectManagerIdListMain
                          ? form.projectManagerIdListMain.length
                          : "" || ""
                      }}
                    </div>
                  </el-form-item>
                  <el-form-item label="项目学员总数">
                    <div>{{ form.projectNumSts || "" }}</div>
                  </el-form-item>
                  <el-form-item label="客户总数">
                    <div>{{ form.customNums || "" }}</div>
                  </el-form-item>
                </div>
                <el-form-item label="项目区域及目标" v-if="form.projectType == 1">
                  <div
                    style="width: 90%;margin: 0 auto; display: flex;flex-direction: row-reverse;"
                  >
                    <el-button
                      v-if="addProjectChild"
                      @click="$form('addProjectChild')"
                      size="small"
                      type="primary"
                      icon="el-icon-circle-plus"
                      >添加项目人员
                    </el-button>
                  </div>
                  <div>
                    <el-table
                      :data="
                        getProjectOne_data.data
                          ? getProjectOne_data.data.projectChildren
                          : []
                      "
                      stripe
                      border
                      style="width: 100%"
                      max-height="300px"
                      :cell-style="{ textAlign: 'center' }"
                      :header-cell-style="{
                        textAlign: 'center',
                        background: 'rgba(0,170,255,0.5)',
                        color: 'black',
                        border: 'none'
                      }"
                    >
                      <el-table-column type="index" label="序号">
                      </el-table-column>
                      <el-table-column prop="srName" label="区域">
                      </el-table-column>
                      <el-table-column
                        prop="projectTeacherIdListString"
                        label="项目老师"
                      >
                      </el-table-column>
                      <el-table-column
                        prop="projectManagerIdListString"
                        label="项目经理"
                      >
                      </el-table-column>
                      <el-table-column prop="userTargetList" label="目标">
                        <template slot-scope="scope">
                          <div
                            v-for="(item, index) in scope.row.userTargetList"
                            :key="index"
                            :style="{ color: item.utMain == 2 ? 'red' : 'black' }"
                          >
                            类型:{{
                              item.utTypeTwo == 1
                                ? "打卡"
                                : item.utTypeTwo == 2
                                ? "金额"
                                : item.utTypeTwo == 3
                                ? "单数"
                                : "业务数"
                            }}
                            业务:{{ item.bcName }} 目标:{{ item.utTarget }}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column label="操作">
                        <template slot-scope="scope">
                          <el-button
                            size="mini"
                            type="text"
                            @click="handleEdit(scope.$index, scope.row)"
                            >编辑</el-button
                          >
                          <el-button
                            size="mini"
                            type="text"
                            @click="handleDelete(scope.$index, scope.row)"
                            style="color: red"
                            >删除</el-button
                          >
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </el-form-item>
                <el-form-item label="项目区域及目标" v-if="form.projectType != 1">
                  <div
                    style="width: 80%;display: flex;justify-content: space-around;"
                  >
                    <div>
                      <span>项目经理:</span>
                      <span
                        ><el-select
                          v-model="form.projectManagerIdList"
                          multiple
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in getUserListXm_data.data || []"
                            :key="item.userId"
                            :label="item.userName"
                            :value="item.userId"
                          >
                          </el-option>
                        </el-select>
                      </span>
                    </div>
                    <div>
                      <span>项目老师:</span>
                      <span>
                        <el-select
                          v-model="form.projectTeacherIdList"
                          multiple
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in getUserListLs_data.data || []"
                            :key="item.userId"
                            :label="item.userName"
                            :value="item.userId"
                          >
                          </el-option>
                        </el-select>
                      </span>
                    </div>
                  </div>
                  <div>
                    <div
                      style="width:100%;display:flex;flex-direction: row-reverse;margin: 10px auto;"
                    >
                      <el-button
                        @click="add_arr"
                        size="small"
                        type="primary"
                        style="margin-right: 30px;"
                        icon="el-icon-circle-plus"
                        >新增目标
                      </el-button>
                    </div>
                    <el-card
                      style="width: 100%;margin:15px 0;"
                      v-for="(item, index) in userTargetListString || []"
                      :key="index"
                    >
                      <el-select
                        v-model="item.utTypeTwo"
                        size="small"
                        style="width: 150px"
                        aria-placeholder="请选择维度类型"
                      >
                        <el-option :key="0" label="打卡" :value="1"></el-option>
                        <el-option :key="1" label="金额" :value="2"></el-option>
                        <el-option :key="2" label="单数" :value="3"></el-option>
                        <el-option :key="3" label="业务数" :value="4"></el-option>
                      </el-select>
                      <el-cascader
                        ref="cascader2"
                        v-model="item.bcId"
                        clearable
                        filterable
                        size="small"
                        :disabled="item.utStatus"
                        :placeholder="item.bcId ? item.bcName : '请选择业务'"
                        :show-all-levels="false"
                        :options="
                          getBusinessClassList_data
                            ? getBusinessClassList_data.data
                            : []
                        "
                        :props="propsTwo"
                        style="width: 150px;"
                      >
                        <template slot-scope="{ data }">
                          <span
                            onclick="this.parentNode.previousElementSibling.click()"
                            >{{ data.bcName }}</span
                          >
                        </template>
                      </el-cascader>
                      <el-input
                        v-model="item.utTarget"
                        size="small"
                        placeholder="请输入目标值"
                        style="width: 150px;"
                      ></el-input>
                      <el-radio-group v-model="item.utMain" style="width: 300px;">
                        <el-radio :label="1">不是主目标</el-radio>
                        <el-radio :label="2">是主目标</el-radio>
                      </el-radio-group>
                      <el-button
                        @click="del_arr(index)"
                        size="small"
                        type="primary"
                        style="float:right"
                        >删除
                      </el-button>
                    </el-card>
                  </div>
                </el-form-item>
                <el-form-item label="项目描述">
                  <el-input
                    v-model="form.projectRemark"
                    style="width: 80%;"
                    placeholder="请输入项目描述"
                  ></el-input>
                </el-form-item>
                <el-form-item label="项目周期">
                  <el-date-picker
                    v-model="form.projectStartTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择开始日期"
                  >
                  </el-date-picker>
                  <span>---</span>
                  <el-date-picker
                    v-model="form.projectEndTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="微课匹配度校验">
                  <el-select v-model="form.microlecturePassStatus">
                    <el-option label="不校验" :value="1"> </el-option>
                    <el-option label="校验" :value="2"> </el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </el-collapse-item>
          </el-collapse>
        </el-card>
        <div
          slot="footer"
          class="dialog-footer"
          style="width: 80%; margin: 10px auto"
          v-if="IsEdit"
        >
          <el-button @click="handleClose2">取 消</el-button>
          <el-button type="success" @click="btnSure2">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      let self = this;
      return {
        projectIdTwo: "",
        userTargetListString: [
          {
            utTypeTwo: "",
            bcId: "",
            utTarget: "",
            utMain: 1
          }
        ],
        projectDetail: false,
        activeNum: ["1"],
        rowShow: "",
        columnShow: "",
        dialogType: 0, //1单选择器,2多选择器,3.次级选择器,4.单日期,5,日期范围,6 radio
        diaLogEditValue: "",
        diaLogEdit: false, //单项编辑
        IsEdit: false,
        zone_arr: [],
        keyValue: 0,
        propsTwo: {
          expandTrigger: "click",
          checkStrictly: true,
          emitPath: false,
          label: "bcName",
          value: "bcId",
          children: "children",
          lazy: true,
          lazyLoad(node, resolve) {
            console.log(node);
            const { level } = node;
            console.log(level);
            self
              .getBusinessClassListTwo({ bcParentId: node.data.bcId })
              .result(res => {
                if (res.data.data) {
                  console.log(level);
                  const nodes = res.data.data.map(item => ({
                    bcId: item.bcId,
                    bcName: item.bcName,
                    leaf: level >= 2
                  }));
                  resolve(nodes);
                }
              });
          }
        },
        props: {
          checkStrictly: true,
          value: "srId",
          label: "srName",
          lazy: true,
          lazyLoad(node, resolve) {
            console.log(node);
            const { level } = node;
            console.log(level);
            self
              .getSysRegionList({ srSuperiorCode: node.data.srCode })
              .result(res => {
                if (res.data.data) {
                  const nodes = res.data.data.map(item => ({
                    srId: item.srId,
                    srName: item.srName,
                    leaf: level >= 2,
                    srCode: item.srCode
                  }));
                  resolve(nodes);
                }
              });
          }
        },
        formRest: {},
        form: {
          srId: "",
          projectId: "",
          projectName: "",
          projectType: "",
          projectManagerIdList: "",
          projectTeacherIdList: "",
          projectStartTime: "",
          projectEndTime: "",
          projectRemark: "",
          projectRange: ""
        },
        diaLogOpen: false,
        projectId: null,
        hasDelete: null,
        hasDeleteData: [
          { id: 1, name: "正常" },
          { id: 2, name: "已删除" }
        ],
        tableColums_getProjectList: {
          $selection: false,
  
          projectName: ["项目名称|fixed:left", 140],
          projectType: [
            "项目类型",
            100,
            "@v-if: 1:统筹类#warn, 2:单训战类#warn, 3:驻训类#warn"
          ],
          projectRange: ["项目领域", 100],
          srName: ["项目区域", 90],
          projectManagerIdListStringTwo: ["项目统筹", 140],
          projectManagerIdListString: ["项目经理", 140],
  
          projectTeacherIdListString: ["项目老师", 140],
          projectNumSts: ["项目学员人数", 140],
          projectProgressTime: ["项目时间进度", 180],
          projectProgressTarget: ["项目目标进度", 180],
          projectProgressDes: ["项目情况", 100],
          projectRemark: ["项目描述", 200],
          // projectData: [
          //   '项目数据', 90,
          //   `@text: 查看
          //      @click:
          //       $form("getProjectOneStatistic", $this.row = $row);
          //       getProjectOneStatistic({projectId:$row.projectId});
          //   `,
          // ],
          projectStartTime: ["开始时间", 140],
          projectEndTime: ["结束时间", 140],
          projectUserTwo: this.updateProjectAuth && [
            "项目权限",
            90,
            `@text: 分配权限
             @click:
                $form("updateProjectAuth", $this.row = $row);
                getRoleAuthListByProjectAll({projectId:0}).result(re=>{
                  getRoleAuthListByProject({projectId:$row.projectId})
                    .trigger(res=>{
                      forLoop(res=res.data.data||[],v=>{
                        $refs.ElTree.setChecked(v.authId,true);
                      });
                      Myformdata.authListString = res + '';
                    });
                });
            `
          ],
  
          // ycDelete: ['状态', 80, '@v-if: 1:正常#success, 2:已删除#danger'],
          projectStatus: [
            "状态",
            80,
            "@v-if: 1:正常#success, 2:已过期#warn, 3:已删除#danger"
          ],
          $operation: (this.updateProject || this.deleteProject) && [
            "操作|fixed:right",
            120,
  
            this.updateProject &&
              `@text: 编辑#warn
             @click:EditProject($row)
            `,
            // $form("updateProject",$row)
            this.deleteProject &&
              `@text: 删除#danger
             @click: _confirm('确定要删除该项目吗?')
                     .trigger('deleteProject',{projectId:$row.projectId})
                     .trigger('getProjectList')
            `
          ]
        },
        tableColums_getProjectUser: {
          $selection: false,
  
          userName: "用户名",
          puLeader: ["权限", , "@v-if: 1:可查看, 2:可编辑#danger"],
  
          $operation: this.deleteProjectUser && [
            "操作",
            200,
  
            `@text: 删除#danger
             @click: _confirm('确定要删除吗?')
                     .trigger('deleteProjectUser',{puId:$row.puId})
                     .trigger('getProjectUser',{projectId:row.projectId})
            `
          ]
        },
  
        tableColums_getProjectUserList: {
          $selection: false,
  
          userName: "用户名",
          userAccount: ["工号", 120],
          userPhone: ["手机号", 120],
          postId: [
            "岗位",
            80,
            "@v-if: 1:平台管理, 2:战队管理, 3:项目经理, 4:老师, 5:学员, 6:项目管理员"
          ],
          yutName: ["类型", 80],
          roleNames: ["角色", 80],
          loginLastTime: ["最后登录时间|sortable", 150],
          createtime: ["创建时间|sortable", 150]
        }
      };
    },
  
    watch: {
      getProjectList_data(newVal) {
        console.log(newVal);
      }
    },
  
    methods: {
      getData() {
        this.getProjectUserList({
          currentPage: 1,
          pageSize: 10,
          postId: 5,
          projectId: this.projectIdTwo
        });
      },
      add_arr() {
        const s = {
          utTypeTwo: "",
          bcId: "",
          utTarget: "",
          utId: ""
        };
        this.userTargetListString.push(s);
      },
      del_arr(index) {
        if (this.userTargetListString.length == 1) {
          return this.$message({
            type: "danger",
            message: "需最少保留一组!"
          });
        } else {
          this.userTargetListString.splice(index, 1);
        }
      },
      projectDetailClose() {
        this.handleClose();
        this.projectDetail = false;
      },
      projectDetailClick(row) {
        console.log("11");
        this.getProjectOne({ projectId: row.projectId }).result(res => {
          this.form = JSON.parse(JSON.stringify(res.data.data));
          this.userTargetListString =
            this.form.userTargetList.length > 0
              ? this.form.userTargetList
              : this.userTargetListString;
          this.projectDetail = true;
        });
      },
      activeNumChange(e) {},
      // apiType 接口类型, row 行数据, type 类型, dataArr 列表数组, value 绑定的值, keyId 列表数组的id,
      //  keyName 列表数组的名字, keyValue 需获取值的属性, title 标题,keyValueTwo 需获取值的第二个属性,valueTwo绑定的第二个值
      DiaLogEditClick(
        apiType,
        row,
        type,
        dataArr,
        value,
        keyId,
        keyName,
        keyValue,
        title,
        keyValueTwo,
        valueTwo
      ) {
        const s = {
          apiType,
          value,
          valueTwo,
          title,
          dataArr,
          keyId,
          keyName,
          keyValue,
          keyValueTwo,
          Id: row.projectId,
          projectParentId: row.projectParentId
        };
        this.dialogType = type;
        this.diaLogEditValue = s;
        this.diaLogEdit = true;
      },
      DiaLogEditSure() {
        this.$confirm("确定要提交吗?, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            const s = {};
            let formData = new FormData();
            s.projectId = this.diaLogEditValue.Id;
            s[this.diaLogEditValue.keyValue] = Array.isArray(
              this.diaLogEditValue.value
            )
              ? this.diaLogEditValue.value.toString()
              : this.diaLogEditValue.value;
            if (this.diaLogEditValue.keyValueTwo) {
              s[this.diaLogEditValue.keyValueTwo] = Array.isArray(
                this.diaLogEditValue.valueTwo
              )
                ? this.diaLogEditValue.valueTwo.toString()
                : this.diaLogEditValue.valueTwo;
              formData.append(
                this.diaLogEditValue.keyValueTwo,
                s[this.diaLogEditValue.keyValueTwo]
              );
            }
            formData.append(
              this.diaLogEditValue.keyValue,
              s[this.diaLogEditValue.keyValue]
            );
            formData.append("projectId", s.projectId);
            if (this.diaLogEditValue.apiType == 1) {
              this.updateProjectManage(formData).result(res => {
                if (res.data.data) {
                  console.log(this.diaLogEditValue);
                  if (this.diaLogEditValue.projectParentId != 0) {
                  }
                  this.handleDiaLogEditClose();
                  this.getProjectList({ hasDelete: this.hasDelete });
  
                  this.$message({
                    type: "success",
                    message: "成功!"
                  });
                }
              });
              return;
            }
            this.updateProjectTwo(formData).result(res => {
              if (res.data.data) {
                this.handleDiaLogEditClose();
                this.getProjectList({ hasDelete: this.hasDelete });
                this.$message({
                  type: "success",
                  message: "成功!"
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消"
            });
          });
      },
      DialogEditChange(value) {
        this.diaLogEditValue.value = value[value.length - 1];
      },
      handleDiaLogEditClose() {
        this.diaLogEditValue = "";
        this.dialogType = 0;
        this.diaLogEdit = false;
      },
      cellMouseEnter(row, column, cell, event) {
        this.rowShow = row.projectId;
        this.columnShow = column.property;
      },
      cellMouseLeave(row, column, cell, event) {
        this.rowShow = "";
        this.columnShow = "";
      },
      hasChildrenChange(value) {
        if (value.projectType == 1 && value.projectParentId == 0) {
          return (value.hasChildren = true);
        } else {
          return (value.hasChildren = false);
        }
      },
      expand(row, expanded) {
        if (row.dtLevel == 1 || row.hasChildren2 === false) return;
        const treeData = this.$refs.mytable.Table.store.states.treeData,
          projectChildren = (treeData[row._parent] || 0).projectChildren || "";
        if (projectChildren.length < 2) return;
        // console.error(row, expanded, row._parent, children, row.hasChildren);
        for (let id of projectChildren) {
          if (id !== row.projectId)
            treeData[id] && (treeData[id].expanded = false);
        }
        return;
      },
      lazyLoad(treeData, treeNode, resolve) {
        console.log(treeData);
        this.getProjectListTwo({ projectParentId: treeData.projectId }).result(
          res => {
            if (res.data.data) {
              let now;
              res = res.data.data || [];
              if (res.length !== 0)
                return (
                  (treeData.hasChildren2 = true),
                  resolve(
                    forArr(
                      res,
                      v => (
                        (v.hasChildren = false), (v._parent = treeData.projectId)
                      )
                    )
                  )
                );
              (treeData.hasChildren2 = false), resolve([]);
            } else {
              resolve([]);
            }
          }
        );
      },
      EditProject(row) {
        this.getProjectOne({ projectId: row.projectId }).result(res => {
          this.form = JSON.parse(JSON.stringify(res.data.data));
          this.userTargetListString = this.form.userTargetList;
          this.diaLogOpen = true;
          this.IsEdit = true;
        });
      },
      btnSure2() {
        this.$confirm("确定要提交吗?, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            if (this.form.projectType != 1) {
              this.form.userTargetListString = JSON.stringify(
                this.userTargetListString
              );
            }
            this.updateProject(this.form).result(res => {
              if (res.data.data) {
                this.handleClose2();
                this.$message({
                  type: "success",
                  message: "成功!"
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消"
            });
          });
      },
      btnSure() {
        this.$confirm("确定要提交吗?, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            if (this.form.projectType != 1) {
              this.form.userTargetListString = JSON.stringify(
                this.userTargetListString
              );
            }
            this.updateProject(this.form).result(res => {
              if (res.data.data) {
                this.handleClose();
                this.$message({
                  type: "success",
                  message: "成功!"
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消"
            });
          });
      },
      myformTable(submit, Myformdata) {
        Myformdata.projectParentId = this.form.projectId;
        Myformdata.userTargetListString = JSON.stringify(
          this.userTargetListString
        );
        submit();
      },
      handleEdit(index, row) {
        console.log(row);
        row.userTargetListString = row.userTargetList;
        this.userTargetListString = row.userTargetList;
        this.$form("updateProjectManage", row);
      },
      handleDelete(index, row) {
        this._confirm("确定要删除吗?").trigger("deleteProject", {
          projectId: row.projectId
        });
      },
      getSysRegionList_api(data) {
        this.getSysRegionList({ srSuperiorCode: data.srCode }).result(res => {
          const node = res.data.data.map(item => ({
            srId: item.srId,
            label: srName,
            leaf: level >= 2
          }));
          return res.data.data;
        });
      },
      handleChange2(value) {
        console.log(value);
        this.form.srId = value[value.length - 1];
      },
      handleChange3(value) {
        console.log(value);
        this.Myformdata.srId = value[value.length - 1];
      },
      sureProject() {
        this.addProject(this.form).result(res => {
          console.log(res);
          this.form.projectId = res.data.data.projectId;
        });
      },
      handleClose() {
        this.diaLogOpen = false;
        this.form = JSON.parse(JSON.stringify(this.formRest));
        this.userTargetListString = [
          {
            utTypeTwo: "",
            bcId: "",
            utTarget: "",
            utId: "",
            utMain: 1
          }
        ];
        this.getProjectList({ hasDelete: this.hasDelete });
        this.IsEdit = false;
      },
      handleClose2() {
        this.userTargetListString = [
          {
            utTypeTwo: "",
            bcId: "",
            utTarget: "",
            utId: "",
            utMain: 1
          }
        ];
        this.IsEdit = false;
      },
      hasDeleteChange(e) {
        this.hasDelete = e;
        this.getProjectList({ hasDelete: this.hasDelete });
      }
    },
    mounted() {
      console.log(this.$refs.mytable);
      this.$refs.mytable.Table.doLayout();
    },
    created() {
      this.formRest = JSON.parse(JSON.stringify(this.form));
      this.getProjectList({ hasDelete: this.hasDelete });
      this.getSysRegionList().result(res => {
        this.zone_arr = res.data.data;
      });
      this.getUserListXm({ pageSize: 0, postId: 3, postPm: 1 });
      this.getUserListLs({ pageSize: 0, postId: 4, postPm: 1 });
      this.getBusinessClassList({ bcParentId: 0 });
    }
  };
  </script>
  
  <style scoped></style>
  


// WEBPACK FOOTER //
// src/views/unipue/ProjectManage_admin.vue